export class ProductCharacteristicModel {
  id: number;
  label: string;
  value: string;
  additionalInfo: string;
  title: string;
}
